// Handle drone targeting
const targetDrone = (targetZone, targetIndex, ws, setError, setDroneTargetMode, setSelectedDroneId, setSelectedDroneInstanceId, selectedDroneId, selectedDroneInstanceId, gameId, gameState, userId) => {
  if (!ws || ws.readyState !== 1) {
    setError("Connection lost. Please refresh the page.");
    return;
  }

  // Determine targetUnitId based on zone and game state
  let targetUnitId = null;
  if (targetZone === "opponent_front" || targetZone === "opponent_flank") {
    // Find the opponent player ID
    const opponentId = gameState?.players?.find(id => id !== userId);
    targetUnitId = opponentId;
  } else {
    // Target is friendly (current player)
    targetUnitId = userId;
  }

  // Get the target unit instance to get its instanceId
  // Normalize zone name (remove 'opponent_' prefix if present)
  const normalizedZone = targetZone.replace('opponent_', '');
  const targetPlayer = gameState?.state?.[targetUnitId];
  const targetUnit = targetPlayer?.playedOrders?.[normalizedZone]?.[targetIndex];
  const targetInstanceId = targetUnit?.instanceId;

  // Send drone activation action with targeting information
  const action = {
    type: "play-turn",
    gameId: gameId,
    action: {
      type: "activateDrone",
      droneId: selectedDroneId,                      // Order ID
      droneInstanceId: selectedDroneInstanceId,      // ✅ REQUIRED: Unique instance ID
      targetUnitId: targetUnitId,
      targetZone: targetZone,
      targetIndex: targetIndex,
      targetInstanceId: targetInstanceId
    }
  };

  ws.send(JSON.stringify(action));
  
  // Reset drone targeting
  setDroneTargetMode(false);
  setSelectedDroneId(null);
  setSelectedDroneInstanceId(null); // ✅ Reset instance ID too
};

export default targetDrone;
